<template>
	<link-dialog
		:key="tableKey"
		v-bind="dialogProps"
		v-model="showFlag"
		@confirm="onConfirm"
		@cancel="onCancel"
	>
		<link-table v-bind="tableProps">
			<link-table-column-index/>
			<link-rendering-render-func v-if="!!option && !!option.render" :render-func="option.render"/>
		</link-table>
	</link-dialog>
</template>

<script>

	import LinkRenderingRenderFunc from "../../render/link-rendering-render-func";

	export default {
		name: "link-tree-object-dialog",
		components: {LinkRenderingRenderFunc},
		provide() {
			return {
				treeObjectDialog: this,
			}
		},
		data() {
			return {
				showFlag: false,
				option: null,
				tableData: [],
				isLoading: false,
				tableKey: 1,

				/**
				 * treeColumn组件初始化会自动赋值给当前组件
				 * @author  韦胜健
				 * @date    2020/10/28 17:44
				 */
				// treeColumn: null,
			}
		},
		computed: {
			dialogProps() {
				const dialogProps = {
					dialogClass: 'link-tree-object-dialog',
					width: '1000px',
					title: LinkVue.$t('LinkForm.selectPlaceholder'),
					initialized: true,
					confirmButton: true,
					cancelButton: true,
					// noPadding: true,
					vertical: 'center',
					horizontal: 'center',
					disabledHideOnConfirm: true,
					enterToConfirm: false,
					loading: this.isLoading,
				}
				if (!!this.option) {
					if (!!this.option.dialogProps) {
						const {dialogClass, ...leftProps} = this.option.dialogProps
						Object.assign(dialogProps, leftProps)
						if (!!dialogClass) {
							dialogProps.dialogClass = `${dialogProps.dialogClass} ${dialogClass}`
						}
					}
				}
				return dialogProps
			},
			tableProps() {
				const props = {
					data: this.tableData,
					rowNum: 10,
					treeConfig: {},
				}
				if (!!this.option) {
					props.treeConfig = this.option.treeConfig
					if (!!this.option.tableProps) {
						Object.assign(props, this.option.tableProps)
					}
				}
				return props
			},
		},
		methods: {
			resetData() {
				this.tableData = []
				this.currentSelected = null
			},
			async show(option) {
				this.resetData()

				this.option = option
				this.tableKey++;
				this.loadData()
				await this.$lv.nextTick()
				this.showFlag = true
			},
			async loadData() {
				this.isLoading = true
				this.tableData = await this.option.data()
				this.isLoading = false
			},
			async onConfirm() {
				if (this.treeColumn.showCheckbox) {
					let selected = this.treeColumn.treeUtils.methods.getCheckedData()
					if (selected.length === 0) {
						return this.$message.error('请至少选中一行数据！')
					}
					if (!!this.option.beforeConfirm) {
						selected = (await (this.option.beforeConfirm(selected))) || selected
					}
					this.option.onConfirm(selected)
				} else {
					let selected = this.treeColumn.treeUtils.methods.getCheckedData()
					if (!selected) {
						return this.$message.error('未选中任何数据！')
					}
					if (!!this.option.beforeConfirm) {
						selected = (await (this.option.beforeConfirm(selected))) || selected
					}
					this.option.onConfirm(selected)
				}
				this.showFlag = false
			},
			onCancel() {
				if (!!this.option && !!this.option.onCancel) {
					this.option.onCancel()
				}
			},
		},
	}
</script>

<style lang="scss">

</style>